import { ChevronLeft, ChevronRight, Download, FileText, X } from "lucide-react";
import { useEffect } from "react";
import { createPortal } from "react-dom";

export const fileUrl = (leadId, a) => `${process.env.REACT_APP_BACKEND_URL}/api/pipeline/leads/${leadId}/attachments/${a.id}/file`;
export const kindOf = (a) => {
  const t = (a.content_type || "").toLowerCase();
  const n = (a.name || "").toLowerCase();
  if (t.startsWith("image/") || /\.(png|jpe?g|gif|webp|heic)$/.test(n)) return "image";
  if (t.includes("pdf") || n.endsWith(".pdf")) return "pdf";
  if (t.startsWith("audio/") || /\.(webm|ogg|mp3|m4a|wav)$/.test(n)) return "audio";
  return "file";
};

export const AttachmentView = ({ leadId, a }) => {
  const kind = kindOf(a);
  if (kind === "image") return <img src={fileUrl(leadId, a)} alt={a.name} />;
  if (kind === "audio") return <div className="pl-att-none"><audio controls src={fileUrl(leadId, a)} data-testid="attachment-audio" /><p>{a.name}</p></div>;
  if (kind === "pdf") return <iframe src={`${fileUrl(leadId, a)}#toolbar=0&view=FitH`} title={a.name} />;
  return <div className="pl-att-none"><FileText size={42} /><p>Aperçu indisponible pour ce type de fichier.</p><a href={fileUrl(leadId, a)} download={a.name} className="primary-button">Télécharger</a></div>;
};

export const HoverPreview = ({ leadId, a, side }) => createPortal(
  <div className={`pl-att-hover ${side}`} data-testid="attachment-hover-preview"><header>{a.name}</header><div className="pl-att-hover-body"><AttachmentView leadId={leadId} a={a} /></div></div>,
  document.body,
);

export function Lightbox({ leadId, items, index, setIndex, onClose }) {
  const a = items[index];
  useEffect(() => {
    const key = (e) => {
      if (e.key === "Escape") { e.stopPropagation(); e.preventDefault(); onClose(); }
      if (e.key === "ArrowRight") setIndex((index + 1) % items.length);
      if (e.key === "ArrowLeft") setIndex((index - 1 + items.length) % items.length);
    };
    window.addEventListener("keydown", key, true);
    return () => window.removeEventListener("keydown", key, true);
  }, [index, items.length, onClose, setIndex]);
  if (!a) return null;
  return createPortal(
    <div className="pl-att-lightbox" onClick={onClose} onPointerDown={(e) => e.stopPropagation()} onFocus={(e) => e.stopPropagation()} data-testid="attachment-lightbox">
      <div className="pl-att-lbbar" onClick={(e) => e.stopPropagation()}>
        <strong>{a.name}</strong><small>{index + 1} / {items.length}</small>
        <a href={`${fileUrl(leadId, a)}?name=${encodeURIComponent(a.name)}`} download={a.name} aria-label="Télécharger" data-testid="attachment-lightbox-download"><Download size={18} /></a>
        <button type="button" onClick={onClose} aria-label="Fermer" data-testid="attachment-lightbox-close"><X size={20} /></button>
      </div>
      {items.length > 1 && <button type="button" className="pl-att-nav prev" onClick={(e) => { e.stopPropagation(); setIndex((index - 1 + items.length) % items.length); }} aria-label="Précédente" data-testid="attachment-lightbox-prev"><ChevronLeft size={28} /></button>}
      <div className="pl-att-lbbody" onClick={(e) => e.stopPropagation()}><AttachmentView key={a.id} leadId={leadId} a={a} /></div>
      {items.length > 1 && <button type="button" className="pl-att-nav next" onClick={(e) => { e.stopPropagation(); setIndex((index + 1) % items.length); }} aria-label="Suivante" data-testid="attachment-lightbox-next"><ChevronRight size={28} /></button>}
    </div>,
    document.body,
  );
}
